import React from "react";
import Router from 'next/router';
import { Localized } from "fluent-react/compat";
import { connect } from "react-redux";
import ButtonDefault from "../ButtonDefault";
import { captureException } from "../../../utils/logRocket";
import { initErrorPayment } from '../../../services/actions/error.actions';

const ErrorService = ({
  buttonAction = "reload",
  dataMessage = "",
  displayButtonReload,
  errorMessage,
  errorMessageSecond = "",
  initErrorPayment,
  nameRestaurant,
  products
}) => {
  const handleRedirectToMenu = () => {
    initErrorPayment();
    Router.push(
      "/commande-en-ligne/[idRestaurant]/carte",
      `/commande-en-ligne/${Router.query.idRestaurant}/carte`
    );
  }
  const refreshWindow = () => {
    buttonAction === "reload" ? window.location.reload() : handleRedirectToMenu();
  };
  const buttonTranslation = buttonAction === "reload" ? "tr-retry" : "tr-redirect-to-menu";

  const restaurantName = nameRestaurant;

  captureException({ message: "C&C Service Error" }, { detail: errorMessage })
  return (
    <div className="container-error-service">
      <div className="container-display-error-service">
        <p>
          <Localized id={errorMessage} $restaurantName={restaurantName} $products={products} /> {dataMessage}
        </p>
        <p>
          {" "}
          <Localized id={errorMessageSecond} />
        </p>
        {displayButtonReload ? (
          <ButtonDefault
            buttonClass="button-retry"
            translation={buttonTranslation}
            sendData={refreshWindow}
          />
        ) : null}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  const { restaurant } = state;
  return { nameRestaurant: restaurant.infoRestaurant.name, products: state.error.errorPayment.products };
};

const actionCreators = {
  initErrorPayment,
}

export default connect(mapStateToProps, actionCreators)(ErrorService);
